<template>
  <div class="dialog-thesis-edit">
    <Form :model="formData" :label-width="160" ref="thesisEditForm" inline>
      <FormItem v-for="item in formItems"
                :key="item.name"
                :style="item.style"
                :label="item.label"
                :prop="item.name"
                :rules="(readonly||item.readonly)?[]:item.rules">
        <component
            v-model="formData[item.name]"
            :is="getDisplayComponent(item.component)"
            :ref="item.name"
            :readonly="readonly||item.readonly"
            :label="formData[item.labelname]"
            :label-prop="item.labelname"
            :options="item.options"
            @on-change="changeOnSelect(item)"
            @on-label-change="changeOnSelectForLabel"
        >
        </component>
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
import ElementInput from '@/components/elements/input'
import ElementSelect from '@/components/elements/select'

/* global BaseConfig:true */
export default {
  name: 'uploadThesis',
  components: {ElementInput, ElementSelect},
  props: {
    query: ''
  },
  data () {
    return {
      id: '',
      readonly: false,
      baseConfig: {},
      formLoading: true,
      formItems: [
        {
          label: '省市名称：',
          name: 'provinceName',
          readonly: true,
          component: 'input'
        },
        {
          label: '单位名称：',
          name: 'unitName',
          readonly: true,
          component: 'input'
        },
        {
          label: '所在院系：',
          name: 'academyName',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '所在院系不能为空', trigger: 'blur'}]
        },
        {
          label: '学号：',
          name: 'schoolNo',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '学号不能为空', trigger: 'blur'}]
        },
        {
          label: '作者姓名：',
          name: 'authorName',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '作者姓名不能为空', trigger: 'blur'}]
        },
        {
          label: '导师姓名：',
          name: 'teacherName',
          readonly: false,
          component: 'input'
        },
        {
          label: '一级学科：',
          name: 'firstSubjectCode',
          labelname: 'firstSubjectName',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '一级学科不能为空', trigger: 'blur'}],
          change: 'firstSubjectChange'
        },
        {
          label: '二级学科：',
          name: 'secondSubjectCode',
          labelname: 'secondSubjectName',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '二级学科不能为空', trigger: 'blur'}]
        },
        {
          label: '论文题目：',
          name: 'titleCn',
          readonly: false,
          component: 'input',
          style: 'width: calc(100% - 10px);',
          rules: [{required: true, message: '论文题目不能为空', trigger: 'blur'}]
        },
        {
          label: '论文英文题目：',
          name: 'titleEn',
          readonly: false,
          component: 'input',
          style: 'width: calc(100% - 10px);'
        },
        {
          label: '论文涉及的研究方向：',
          name: 'researchAera',
          readonly: false,
          component: 'input'
        },
        {
          label: '论文关键词：',
          name: 'keyWord',
          readonly: false,
          component: 'input'
        },
        {
          label: '攻读学位类别：',
          name: 'degreeType',
          labelname: 'typeName',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '攻读学位类别不能为空', trigger: 'blur'}]
        },
        {
          label: '攻读学位方式：',
          name: 'degreeMode',
          labelname: 'modeName',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '攻读学位方式不能为空', trigger: 'blur'}]
        },
        {
          label: '学习方式：',
          name: 'learningStyle',
          labelname: 'learningStyleMc',
          readonly: false,
          component: 'select',
          options: [{value: '1', label: '全日制'}, {value: '2', label: '非全日制'}],
          rules: [{required: true, message: '学习方式方式不能为空', trigger: 'blur'}]
        },
        {
          label: '送审专家数：',
          name: 'auditExpertNum',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '送审专家数不能为空', trigger: 'blur'}]
        }
      ],
      formData: {
        provinceName: '',
        unitName: '',
        academyCode: '',
        academyName: '',
        schoolNo: '',
        authorName: '',
        teacherName: '',
        firstSubjectCode: '',
        firstSubjectName: '',
        secondSubjectCode: '',
        secondSubjectName: '',
        titleCn: '',
        titleEn: '',
        researchAera: '',
        keyWord: '',
        degreeType: '',
        degreeMode: '',
        auditExpertNum: ''
      },
      defaultFormData: {}
    }
  },
  created () {
    this.baseConfig = BaseConfig;

    this.id = this.query.split('&')[0];
    this.readonly = this.query.split('&')[1] === 'readonly';

    if (!this.readonly) {
      this.fetchThesisMessage('/paper/paperBaseInfo/info/');

      this.fetchSubjectOptions(6, {});
      this.fetchDegreeType();
      this.fetchDegreeMode();
    } else {
      this.fetchThesisMessage('/paper/paperBaseInfo/queryPaperById/');
    }
  },
  methods: {
    getDisplayComponent (display) {
      return 'Element' + display.replace(display.charAt(0), display.charAt(0).toUpperCase());
    },
    fetchThesisMessage (url) {
      this.fetch(url + this.id).then(res => {
        this.formData = Object.assign(this.formData, res.data);

        // 如果一级学科存在值且可编辑状态，则获取二级学科的列表
        if (this.formData.firstSubjectCode && !this.readonly) {
          this.fetchSubjectOptions(7, {code: this.formData.firstSubjectCode});
        }

        // 数字类型数据，导致prop表单验证为空，转为字符串
        this.formData.auditExpertNum = this.formData.auditExpertNum + '';
        this.defaultFormData = JSON.parse(JSON.stringify(this.formData));
        this.formLoading = false;
      });
    },
    fetchSubjectOptions (number, query) {
      this.formItems[number].options = [];
      let url = '/conf/confSecondSubject/query';
      if (number === 6) {
        url = '/conf/confFirstSubject/all';
      }
      this.post(url, query).then(res => {
        for (let subject of res.data) {
          this.formItems[number].options.push({
            id: subject.id,
            value: subject.code,
            label: subject.name
          });
        }
      });
    },
    changeOnSelect (item) {
      if (item.change === 'firstSubjectChange') {
        this.fetchSubjectOptions(7, {code: this.formData[item.name]});
      }
    },
    /**
     * 获取学位类别列表
     */
    fetchDegreeType () {
      this.post('/conf/confDegreeType/queryDegreeTypeList').then(res => {
        for (let type of res.data) {
          this.formItems[12].options.push({
            value: type.id,
            label: type.name
          });
        }
      });
    },
    /**
     * 获取学位攻读方式列表
     */
    fetchDegreeMode () {
      this.post('/conf/confDegreeMode/queryDegreeModeList').then(res => {
        for (let mode of res.data) {
          this.formItems[13].options.push({
            value: mode.id,
            label: mode.name
          });
        }
      });
    },
    changeOnSelectForLabel (name, value) {
      this.formData[name] = value;
    },
    dialogComfirm () {
      const _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs['thesisEditForm'].validate((valid) => {
          if (valid) {
            let param = _self.compare(_self.defaultFormData, _self.formData);

            if (Object.keys(param).length === 0) {
              resolve();
              return;
            }

            if (_self.defaultFormData.id) {
              param.id = _self.defaultFormData.id;
            }
            _self.post('/paper/paperBaseInfo/saveOrUpdate', param).then(res => {
              resolve();
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
}
</script>

<style lang="less">
  .dialog-thesis-edit {
    .kh-form-inline {
      .kh-form-item {
        width: calc(50% - 10px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/dialogs/thesisManage/thesisEdit.vue